import "./App.css";
import he from "./locale/he.json";
import en from "./locale/en.json";

import React, { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import { Provider as MobxProvider } from "mobx-react";
import { GlobalStyles } from "./common/UI";
import Layout from "./layouts/Layout";
import AppRoutes from "./Routes";
import theme from "./theme";
import i18next from "i18next";
import { initReactI18next, useTranslation } from "react-i18next";
import stores from "./stores";
import SuccesScreen from "./components/SuccesScreen";

i18next.use(initReactI18next).init({
  resources: {
    he: he,
    en: en,
  },
  fallbackLng: "en",
  lng: "he",
  languages: ["he", "en"],
  interpolation: {
    escapeValue: false,
  },
});

const App = () => {
  const { t } = useTranslation("common");

  useEffect(() => {
    document.title = t("title");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <MobxProvider {...stores}>
      <>
        <GlobalStyles />
        <BrowserRouter>
          <ThemeProvider theme={theme}>
            <Layout>
              <AppRoutes />
              <SuccesScreen />
            </Layout>
          </ThemeProvider>
        </BrowserRouter>
      </>
    </MobxProvider>
  );
};

export default App;
